<template>
  <div>
    <div class="newQuestionsBackground md:py-12 dark:bg-purple-600">
      <div class="buttonDiv">
        <BackButton />
        <h2 class="questionTitle dark:text-white">
          There are specific support services tailored to supporting the
          following identities. If you would like to be provided with these
          specific services, please select all that apply.
        </h2>
        <!-- Q4-1-->
        <div data-aos="fade-left" class="checkboxes">
          <span
            v-if="
              $store.state.views.questionFour.checkedButtons[0] === idArr[0]
            "
          >
            <input
              type="checkbox"
              id="option1"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option1" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[0] }}
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option1"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option1" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[0] }}
            </label>
          </span>

          <!-- Q4-2-->

          <span
            v-if="
              $store.state.views.questionFour.checkedButtons[1] === idArr[1]
            "
          >
            <input
              type="checkbox"
              id="option2"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option2" class="dark:text-white dark:bg-hero-purple">
              2SLGBTQ+ community</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option2"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option2" class="dark:text-white dark:bg-hero-purple">
              2SLGBTQ+ community</label
            >
          </span>

          <!-- Q4-3-->

          <span
            v-if="
              $store.state.views.questionFour.checkedButtons[2] === idArr[2]
            "
          >
            <input
              type="checkbox"
              id="option3"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option3" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[2] }}</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option3"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option3" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[2] }}</label
            >
          </span>

          <!-- Q4-4-->

          <span
            v-if="
              $store.state.views.questionFour.checkedButtons[3] === idArr[3]
            "
          >
            <input
              type="checkbox"
              id="option4"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option4" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[3] }}</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option4"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option4" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[3] }}</label
            >
          </span>

          <!-- Q4-5-->

          <span
            v-if="
              $store.state.views.questionFour.checkedButtons[4] === idArr[4]
            "
          >
            <input
              type="checkbox"
              id="option5"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option5" class="dark:text-white dark:bg-hero-purple">
              Women in the field(s) of science, engineering, and
              mathematics</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option5"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option5" class="dark:text-white dark:bg-hero-purple">
              Women in the field(s) of science, engineering, and
              mathematics</label
            >
          </span>

          <!-- Q4-6-->

          <span
            v-if="
              $store.state.views.questionFour.checkedButtons[5] === idArr[5]
            "
          >
            <input
              type="checkbox"
              id="option6"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option6" class="dark:text-white dark:bg-hero-purple">
              Trans/Non-Binary
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option6"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option6" class="dark:text-white dark:bg-hero-purple">
              Trans/Non-Binary
            </label>
          </span>

          <!-- Q4-7-->

          <span
            v-if="
              $store.state.views.questionFour.checkedButtons[6] === idArr[6]
            "
          >
            <input
              type="checkbox"
              id="option7"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option7" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[6] }}</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option7"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option7" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[6] }}</label
            >
          </span>

          <!-- Q4-8-->

          <span
            v-if="
              $store.state.views.questionFour.checkedButtons[7] === idArr[7]
            "
          >
            <input
              type="checkbox"
              id="option8"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option8" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[7] }}</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option8"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option8" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[7] }}</label
            >
          </span>

          <!-- Q4-9-->

          <span
            v-if="
              $store.state.views.questionFour.checkedButtons[8] === idArr[8]
            "
          >
            <input
              type="checkbox"
              id="option9"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option9" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[8] }}</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option9"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option9" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions[8] }}</label
            >
          </span>
        </div>

        <small class="py-10 my-8 block font-medium dark:text-white">
          <svg
            class="w-4 h-4 float-left mr-2"
            width="108"
            height="108"
            viewBox="0 0 108 108"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M54 0C24.1787 0 0 24.1874 0 54C0 83.83 24.1787 108 54 108C83.8213 108 108 83.83 108 54C108 24.1874 83.8213 0 54 0ZM54 23.9516C59.0507 23.9516 63.1452 28.046 63.1452 33.0968C63.1452 38.1475 59.0507 42.2419 54 42.2419C48.9493 42.2419 44.8548 38.1475 44.8548 33.0968C44.8548 28.046 48.9493 23.9516 54 23.9516ZM66.1935 79.2581C66.1935 80.701 65.0236 81.871 63.5806 81.871H44.4194C42.9764 81.871 41.8065 80.701 41.8065 79.2581V74.0323C41.8065 72.5893 42.9764 71.4194 44.4194 71.4194H47.0323V57.4839H44.4194C42.9764 57.4839 41.8065 56.3139 41.8065 54.871V49.6452C41.8065 48.2022 42.9764 47.0323 44.4194 47.0323H58.3548C59.7978 47.0323 60.9677 48.2022 60.9677 49.6452V71.4194H63.5806C65.0236 71.4194 66.1935 72.5893 66.1935 74.0323V79.2581Z"
              fill="#979797"
            />
          </svg>
          Note: Carleton is committed to continually invest and diversify our support services to meet the needs of our students from equity-seeking communities.
          The team is actively working to add additional resources both on and off campus for marginalized communities and will update the resource lists when possible to reflect this.
        </small>
      </div>
    </div>

    <div
      class="
        alignFooter
        dark:bg-hero-purple
        border-b border-gray-200
        dark:border-hero-purple
      "
    >
      <div class="footerContainer">
        <HelpDialog />

        <button v-on:click="nextQuestion" class="nextButtonQuestions">
          Next
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import BackButton from "./BackButton.vue";
import HelpDialog from "./HelpDialog.vue";
export default {
  data() {
    return {
      answerOptions: {
        0: "Indigenous",
        1: "2SLGBTQ+",
        2: "Muslim",
        3: "Black",
        4: "WISE",
        5: "Trans",
        6: "Racialized",
        7: "Prefer not to answer",
        8: "None of the above",
      },

      idArr: {
        0: "option1",
        1: "option2",
        2: "option3",
        3: "option4",
        4: "option5",
        5: "option6",
        6: "option7",
        7: "option8",
        8: "option9",
      },
      isActive: false,
      flag: true,
    };
  },

  components: { BackButton, HelpDialog },

  mounted: function () {
    this.scrollToTop();
    this.checkPreviousInput();
    this.track();
  },
  methods: {
    track() {
      const currentURL = new URL(location.href);
      const isDemo = currentURL.searchParams.get('demo') === 'true';

      if (!isDemo) {
        this.$gtag.pageview({ page_path: "step4" });
      } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
      }
    },
    checkboxesChecked() {
      var checkboxes = document.getElementsByName("impact[]");
      var total = 0;
      var i;

      //check to see if none of the above is checked
      if (!this.flag) {
        checkboxes[8].checked = false;
        this.flag = true;
      }

      if (checkboxes[8].checked && this.flag) {
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false;
        }
        checkboxes[8].checked = true;
        this.flag = false;
      }

      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          total = total + 1;
        }
      }

      if (total === 0) {
        this.isActive = false;
        store.commit("setNextButtonDeactive", '["questionFour"]');
      } else {
        this.isActive = true;
      }
    },

    nextQuestion() {
      var answerArray = [];
      var activeChecked = [];

      var checkboxes = document.getElementsByName("impact[]");
      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          answerArray.push(this.answerOptions[i]);
        }
      }

      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          activeChecked[i] = checkboxes[i].id;
        } else {
          activeChecked[i] = "NULL";
        }
      }

      for (let i = 0; i < answerArray.length; i++) {
        const currentURL = new URL(location.href);
        const isDemo = currentURL.searchParams.get('demo') === 'true';

        if (!isDemo) {
            this.$gtag.event("q4-answer", {
            event_category: "answers",
            event_label: answerArray[i],
          });
        } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
      }
      }

      var objectForPages = {
        index: '["questionFour"]',
        ans: answerArray,
      };

      var objectForChecked = {
        questionNum: '["questionFour"]',
        checkedButtons: activeChecked,
      };
      store.commit("addAnswer", objectForPages);
      store.commit("setNextButtonActive", '["questionFour"]');
      store.commit("setChecked", objectForChecked);
      store.commit("updatePage", '["questionFive"]');
    },
    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    checkPreviousInput() {
      if (store.state.views.questionFour.checkedButtons[8] === this.idArr[8]) {
        this.flag = false;
      }
    },
  },
};
</script>
